import { render, staticRenderFns } from "./FormWrapper.vue?vue&type=template&id=7ed7b97e&"
import script from "./FormWrapper.vue?vue&type=script&lang=js&"
export * from "./FormWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ed7b97e')) {
      api.createRecord('7ed7b97e', component.options)
    } else {
      api.reload('7ed7b97e', component.options)
    }
    module.hot.accept("./FormWrapper.vue?vue&type=template&id=7ed7b97e&", function () {
      api.rerender('7ed7b97e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/FormWrapper.vue"
export default component.exports